var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTouch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.197,
    height: 95.497,
    viewBox: "0 0 114.197 95.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-03",
    transform: "translate(-31.085 -64.205)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 15.281,
    cy: 15.281,
    r: 15.281,
    transform: "translate(81.821 91.709) rotate(-34.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M201.971,131.606a6.659,6.659,0,0,0-8.307,4.212l-3.492,10.951a18.473,18.473,0,0,1-11.311,11.671,21.826,21.826,0,0,1-7.819,1.322H156.12a18.279,18.279,0,0,0-15.413,8.542l-15.039,24.062a6.576,6.576,0,0,0,2.046,9.023,6.123,6.123,0,0,0,3.489.966,6.743,6.743,0,0,0,5.656-3.115l11.55-18.41V199.48a4.057,4.057,0,0,0,4.091,4.091h23.464a4.057,4.057,0,0,0,4.091-4.091V171.794a31.779,31.779,0,0,0,3.247-.845,31.456,31.456,0,0,0,19.255-19.971l3.489-10.951a6.4,6.4,0,0,0-4.074-8.421Z",
    transform: "translate(-61.195 -43.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M75.553,112.041a2.7,2.7,0,0,0,3.371-3.368l-3.371-9.868a23.639,23.639,0,1,0-9.851,9.868ZM55.1,101.692a2.887,2.887,0,1,1,2.89-2.887,2.928,2.928,0,0,1-2.89,2.887Zm6.981-15.039a11.792,11.792,0,0,1-3.115,3.008,2.656,2.656,0,0,0-1.443,2.527,1.239,1.239,0,0,1-1.326,1.2H54.135a1.291,1.291,0,0,1-1.322-1.443A7.263,7.263,0,0,1,56.3,85.691a7.511,7.511,0,0,0,2.046-1.924,3.153,3.153,0,0,0,.242-3.25c-.346-.723-1.326-1.924-3.731-1.924a3.857,3.857,0,0,0-4.212,3.368,1.409,1.409,0,0,1-1.322,1.083H47.157a1.333,1.333,0,0,1-1.322-1.564,8.765,8.765,0,0,1,9.023-7.819,8.594,8.594,0,0,1,7.94,4.572A8.129,8.129,0,0,1,62.079,86.653Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouch);
export default __webpack_public_path__ + "static/media/touch.64c9d747e6a042b4e3e1d20253ba5cf5.svg";
export { ForwardRef as ReactComponent };